<app-pet-rehome-modal-header></app-pet-rehome-modal-header>

<div class="modal-body">
  <div class="row mt-2">
    <div class="col-12">
      <p>
        A transfer of keepership request for this microchip has already been successfully submitted.
      </p>
      <p>
        We are currently running our security checks on the microchip and gaining permission
        from the current registered keeper to relinquish keepership, this may take up to 28
        working days. If we do not receive confirmation from the previous keeper in this time
        frame, your request will be automatically approved.
      </p>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="onConfirm()">
    Got it
  </button>
</div>
